import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CIRuleAction, ICIRuleAction } from 'src/app/shared/models/ci-rule-action.model';
import { arrayOfType } from 'src/app/shared/utils/data.utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CIRuleActionsService {
  constructor(private readonly httpClient: HttpClient) {}

  getCIRuleActions(): Observable<ICIRuleAction[]> {
    return this.httpClient
      .get<ICIRuleAction[]>(`${environment.sitemanagement_api_url}/v1/insights/conversation/account/action/items`)
      .pipe(map((actions: ICIRuleAction[]) => arrayOfType(actions, CIRuleAction)));
  }
}
